var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 46,
    viewBox: "0 0 52 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bdd_1079_7192)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1079_7192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 4H44V40H8V4Z",
    fill: "url(#paint0_linear_1079_7192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7456 24.7579H14.3148C14.024 24.7579 13.7471 24.6056 13.6086 24.3425C13.4563 24.0379 13.5117 23.6779 13.7471 23.4425L16.8348 20.3548H14.6194C14.0102 20.3548 13.5117 19.8564 13.5117 19.2471H17.6102C17.9009 19.2471 18.1779 19.3994 18.3163 19.6625C18.4686 19.9671 18.4133 20.3271 18.1779 20.5625L15.0902 23.6502H17.6517C18.2609 23.6502 18.7456 24.1487 18.7456 24.7579ZM36.344 19.1641C35.7071 19.1641 35.1394 19.441 34.7379 19.8841C34.3502 19.441 33.7686 19.1641 33.1317 19.1641C31.9548 19.1641 30.9856 20.1748 30.9856 21.3518V24.7579C31.5948 24.7579 32.0933 24.2594 32.0933 23.6502V21.3379C32.0933 20.7702 32.5363 20.2856 33.104 20.2718C33.6994 20.2441 34.1979 20.7287 34.1979 21.3241V23.6641C34.1979 24.2733 34.6963 24.7718 35.3056 24.7718V21.3518C35.3056 20.7841 35.7486 20.2994 36.3163 20.2856C36.9117 20.2579 37.4102 20.7425 37.4102 21.3379V23.6779C37.4102 24.2871 37.9086 24.7856 38.5179 24.7856V21.3794C38.4902 20.1748 37.521 19.1641 36.344 19.1641ZM24.3256 22.0025C24.3256 23.5671 23.0517 24.841 21.4871 24.841C19.9225 24.841 18.6486 23.5671 18.6486 22.0025C18.6486 20.4379 19.9225 19.1641 21.4871 19.1641C23.0517 19.1641 24.3256 20.4379 24.3256 22.0025ZM23.2179 22.0025C23.2179 21.0471 22.4425 20.2718 21.4871 20.2718C20.5317 20.2718 19.7563 21.0471 19.7563 22.0025C19.7563 22.9579 20.5317 23.7333 21.4871 23.7333C22.4425 23.7333 23.2179 22.9579 23.2179 22.0025ZM30.4456 22.0025C30.4456 23.5671 29.1717 24.841 27.6071 24.841C26.0425 24.841 24.7686 23.5671 24.7686 22.0025C24.7686 20.4379 26.0425 19.1641 27.6071 19.1641C29.1717 19.1641 30.4456 20.4379 30.4456 22.0025ZM29.3379 22.0025C29.3379 21.0471 28.5625 20.2718 27.6071 20.2718C26.6517 20.2718 25.8763 21.0471 25.8763 22.0025C25.8763 22.9579 26.6517 23.7333 27.6071 23.7333C28.5625 23.7333 29.3379 22.9579 29.3379 22.0025Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bdd_1079_7192",
    x: -2,
    y: -6,
    width: 56,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1079_7192"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.0862745 0 0 0 0 0.0980392 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1079_7192",
    result: "effect2_dropShadow_1079_7192"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.0862745 0 0 0 0 0.0980392 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1079_7192",
    result: "effect3_dropShadow_1079_7192"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1079_7192",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1079_7192",
    x1: 13.7058,
    y1: 43.2942,
    x2: 38.2942,
    y2: 0.705765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0845BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0B5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6122,
    stopColor: "#1463FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7951,
    stopColor: "#2C76F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F90EE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1079_7192"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 4,
    width: 36,
    height: 36,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIcon);
export default __webpack_public_path__ + "static/media/zoom-icon.6d2dd437a730dab1180c7d1214a226b3.svg";
export { ForwardRef as ReactComponent };